<template>
<div class="popup">
    <div class="content vip_to_unlimit_popup">
        <!-- 标题 -->
        <div class="popup_title">
            <div class="popup_title_bg"></div>
            <div class="popup_title_content">
                <div class="popup_title_main">{{ title }}</div>
                <div class="popup_title_sub">{{ desc }}</div>
                <div class="popup_title_close" @click="$parent.isShow=false"></div>
            </div>
        </div>
        <!-- 内容 -->
        <div class="popup_content">
            <paySchemeTab ref="payScheme" v-for="(allowScheme,index) in allowSchemes" :key="index" :payScheme=allowScheme :index=index isVIP="true" data-popup :data-last="index==allowSchemes.length-1?'Y':'N'"></paySchemeTab>
        </div>
    </div>
</div>
</template>

<script>
import paySchemeTab from '@/components/common/tabs/tabs_pay_system/tab_pay_scheme';
export default {
    name: "upgradeVipDialog",
    components: {
        paySchemeTab,
    },
    computed: {
        allowSchemes() {
            var list = [];
            var paySysRes = this.$store.getters.getPaySysRes;
            var nowSchemeId = paySysRes.nowScheme.id;
            paySysRes.vipSchemes.forEach(function (item) {
                if (item.level == 1) {
                    if (item.id != nowSchemeId) {
                        list.push(item);
                    }
                }
            });
            return list;
        },
    },
    data: function () {
        return {
            // 主标题
            title: this.$t('language.paySystem.supportItem.vipPopupTitleIns'),
            // 描述
            desc: this.$t('language.paySystem.supportItem.vipPopupDescIns'),
        }
    },
    methods: {
        upgradePlan(item) {
            var that = this.$parent;
            while (that && that.$el.className!='work-space') {
                that = that.$parent;
            }
            if (that && that.$el.className=='work-space') {
                that.$refs.paySys.upgradePlan(item);
                this.$parent.isShow = false;
            }
        },
    },
}
</script>

<style scoped>
/* 小屏小弹窗 */
@media (max-width: 1920px) {
    .vip_to_unlimit_popup {
        transform: scale(0.8);
    }
}
/* 外框 */
.content {
    width: 1000px;
    height: 608px;
    border: none;
    border-radius: 8px;
    background: #FFFFFF;
    box-shadow: 0px 10px 10px 0px rgba(87, 94, 136, 0.3);
    font-family: Arial, "Microsoft YaHei", 微软雅黑;
    overflow: hidden;
}
/* 标题框 */
.popup_title {
    height: 169px;
    position: relative;
}
/* 标题背景 */
.popup_title_bg {
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 1;
    left: 0;
    top: 0;
    background-color: #3F4A8D;
    background-image: url("../../../assets/images/imageSaver/upgradePopupBg.png");
    background-blend-mode: overlay;
    background-position: -1px -250px;
    background-size: 1002px 900px;
}
/* 标题内容 */
.popup_title_content {
    width: 100%;
    height: 100%;
    text-align: center;
    position: absolute;
    z-index: 2;
    left: 0;
    top: 0;
}
/* 主标题 */
.popup_title_main {
    margin-top: 56.5px;
    height: 32px;
    line-height: 32px;
    font-size: 24px;
    font-weight: bold;
    color: #FFFFFF;
}
/* 副标题 */
.popup_title_sub {
    margin-top: 10px;
    height: 18px;
    line-height: 18px;
    font-size: 16px;
    font-weight: normal;
    color: #FFFFFF;
}
/* 关闭 */
.popup_title_close {
    width: 30px;
    height: 30px;
    position: absolute;
    z-index: 1;
    right: 10px;
    top: 10px;
    background-image: url("../../../assets/images/imageSaver/upgradeClose.svg");
    cursor: pointer;
}
.popup_title_close:hover {
    background-image: url("../../../assets/images/imageSaver/upgradeCloseHover.svg");
}
.popup_title_close:active {
    background-image: url("../../../assets/images/imageSaver/upgradeCloseActive.svg");
}
/* 主要内容 */
.popup_content {
    position: relative;
}
/* 内容外框 */
.popup_content>div {
    width: 450px;
    height: 360px;
    position: absolute;
    top: 40px;
    box-sizing: border-box;
    border-radius: 12px;
}
/* 覆盖付费套餐样式 */
.pay_scheme_body[data-popup][data-index] {
    box-shadow: none;
    margin-left: 0px;
    height: auto;
}
.pay_scheme_body[data-popup][data-index='0'] {
    left: 40px;
    border: 1px solid rgba(0, 0, 0, 0.08);
    background: linear-gradient(180deg, #FFFFFF 49%, #FFF9F5 100%);
}
.pay_scheme_body[data-popup][data-index='1'] {
    right: 40px;
    border: 1px solid rgba(255, 108, 25, 0.5);
    background: linear-gradient(180deg, #FFF2EB 0%, #FFFFFF 53%), #FFFFFF;
}
.pay_scheme_body[data-popup][data-index='0'][data-last=Y] {
    left: 270px;
}
</style>



// WEBPACK FOOTER //
// src/components/popup/upgrade_popups/upgrade_account_vip_inner_ins_popup.vue